import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

interface SafeHtmlRendererProps {
  html: string;
}

export default function SafeHtmlRenderer({ html }: SafeHtmlRendererProps) {
  const cleanHtml = DOMPurify.sanitize(html);

  return <>{parse(cleanHtml)}</>;
}